import {
  type ApiClient,
  type ApiResponse,
  createApiClient,
  createAxiosInstance,
} from '@commander/api-client';
import type { SearchRequest, UniversalSearchResponse } from './search.types';

export const createSearchApi = (apiClient: ApiClient) => ({
  async search(request: SearchRequest): Promise<UniversalSearchResponse> {
    const params = new URLSearchParams();
    params.set('q', request.q);
    params.set('mode', request.mode ?? 'dropdown');
    if (request.entity) params.set('entity', request.entity);
    if (request.page) params.set('page', String(request.page));
    if (request.perPage) params.set('per_page', String(request.perPage));

    const response = await apiClient.get<ApiResponse<UniversalSearchResponse>>(
      `/search?${params.toString()}`
    );
    return response.data;
  },
});

const defaultAxiosInstance = createAxiosInstance({
  baseURL: import.meta.env?.VITE_API_BASE_URL
    ? import.meta.env.VITE_API_BASE_URL
    : 'http://localhost:9229',
  getToken: () => {
    if (typeof document !== 'undefined') {
      const match = document.cookie.match(/(?:^|; )auth_token=([^;]*)/);
      if (match?.[1]) return decodeURIComponent(match[1]);
    }
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('auth_token');
    }
    return null;
  },
});

export const searchApi = createSearchApi(createApiClient(defaultAxiosInstance));
